<div class="wishlist-container">
    <div class="top-section-container">
        <div class="top-section container">
            <div class="title-container">
                <mat-icon svgIcon="arrowleft" class="left-arrow-icon" (click)="goBack()"></mat-icon>
                <span class="title font-poppins">Wishlist</span>
            </div>
            <div class="wishlist-count">
                @if (wishlistData.length) {
                <span class="wishlist-count-message">My wishlist ({{ wishlistData.length }}) items</span>
                } @else {
                <span class="wishlist-count-message"
                    >Looks like there’s nothing here yet. Start exploring and add items you love!</span
                >
                }
            </div>
        </div>
    </div>

    <div class="button-section-container" [ngClass]="{ 'no-wishlist': !wishlistData.length }">
        @if (isLoading) {
        <mat-spinner class="loading-spinner" [diameter]="50"></mat-spinner>
        } @else if (!isLoading && wishlistData.length) {
        <div class="product-section-container">
            <div class="product-section container">
                @for (product of wishlistData; let i = $index; track i) {
                <app-product-card
                    [product]="product"
                    class="card"
                    [isWishlist]="true"
                    [imageBgClass]="'product-image-gradient' + ((i % 3) + 1)"
                ></app-product-card>
                }
            </div>

            <div class="btn-content" *ngIf="showViewMoreButton()">
                <button mat-stroked-button class="view-more-btn" (click)="loadMoreWishlistItems()">
                    View More Items
                </button>
            </div>
        </div>
        } @else if(!isLoading && !wishlistData.length) {
        <div class="no-cart-container font-poppins">
            <div class="circle">
                <mat-icon [svgIcon]="'search'" class="search-icon"></mat-icon>
                <mat-icon [svgIcon]="'empty'" class="empty-icon"></mat-icon>
            </div>

            <div class="message-container">
                <p class="title">Your Wishlist is Empty</p>

                <p class="subtitle">
                    Add items that you like to your wishlist. Review them anytime and easily move them to the bag.
                </p>

                <button mat-stroked-button class="empty-button" routerLink="/wishlist">
                    <mat-icon [svgIcon]="'arrowleft'" class="checkout-icon"></mat-icon>
                    Continue Shopping
                </button>
            </div>
        </div>
        }
    </div>
</div>
